export default __webpack_public_path__ + "static/cookie-f0e97bc348198fb17e56723fed0c4bd7.jpg";